global.jQuery = require("../node_modules/jquery/dist/jquery.js");
require('../node_modules/owl.carousel/dist/owl.carousel.min.js');
{
	const $ = jQuery;
	$(document).ready(function(){

		$('#usage .owl-carousel').owlCarousel({
			items: 1,
			nav: true,
			dots: true,
			loop: true
		});

		$('aside .owl-carousel').owlCarousel({
			loop: true,
			autoplay: true,
			dots: false,
			autoplaySpeed: 1500,
			responsive: {
				0: {
					items: 3,
					autoplayTimeout: 2000
				},
				720: {
					items: 5,
					autoplayTimeout: 3000
				}
			}
		});

		if (window.innerWidth <= 720) {
			$('#features .owl-carousel').owlCarousel({
				items: 1,
				nav: true,
				navText: ['', ''],
				loop: true,
				dots: false
			});
		}

		$('.newsletter form').on('submit', function(e) {
			e.preventDefault();

			const submitCopy = $('.newsletter form input[type=submit]').val();
			$('.newsletter form input[type=submit]').val('Sending...');
			$('.newsletter form input[type=submit]').attr('disable', 'disable');

			$.ajax({
				method: $(this).get(0).method,
				url: $(this).get(0).action,
				data: $(this).serialize(),
				dataType: 'json',
				error: function(jqXHR, textStatus, errorThrown) {
					$('.newsletter form .error').text(textStatus);
					$('.newsletter form input[type=submit]').val(submitCopy);
					$('.newsletter form input[type=submit]').removeAttr('disable');
				},
				success: function(data, textStatus, jqXHR) {
					if (data.status == 'ok') {
						$('.newsletter form .error').text('');
						$('.newsletter form').fadeOut(function() {
							$('.newsletter .success').fadeIn();
						});
					} else {
						$('.newsletter form input[type=submit]').val(submitCopy);
						$('.newsletter form input[type=submit]').removeAttr('disable');
						$('.newsletter form .error').text(data.message);
					}
				}
			});
		});
	});
}